



















import mixins from 'vue-typed-mixins';
import cloneDeep from 'lodash.clonedeep';
import ProviderTypeForm from '@/components/provider/ProviderTypeForm.vue';
import ProviderUtils, { ServiceProviderType } from '../../utils/ProviderUtils';
export default mixins().extend({
  components: {
    ProviderTypeForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    pristine?: Partial<ServiceProviderType>;
    type?: Partial<ServiceProviderType>;
  } {
    return {
      pristine: undefined,
      type: undefined,
    };
  },
  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([ProviderUtils.api.type.get(this.id)]);
        this.pristine = resp[0];
        this.type = cloneDeep(this.pristine);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
  methods: {
    async submit() {
      if (this.type) {
        try {
          this.$alert.hide('submit');
          await ProviderUtils.api.type.update(this.type);
          this.pristine = cloneDeep(this.type);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.serviceProviderType.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
